import { logger } from '@amzn/atoz-shiftapp-metrics';
import i18n from 'i18next';
// TODO: Deprecate formattedCurrency in favor of this
export var getCurrencyStr = function (currency, options) {
    if (options === void 0) { options = {}; }
    var amount = currency.amount, code = currency.code;
    try {
        var integerFormatter = new Intl.NumberFormat(i18n.language, {
            style: 'currency',
            currency: code,
            minimumFractionDigits: 0
        });
        var rationalFormatter = new Intl.NumberFormat(i18n.language, {
            style: 'currency',
            currency: code,
            minimumFractionDigits: 2
        });
        return amount % 1 === 0 && !(options === null || options === void 0 ? void 0 : options.forceRationalFormatting)
            ? integerFormatter.format(amount)
            : rationalFormatter.format(amount);
    }
    catch (err) {
        logger.emitError('getCurrencyStr received an invalid currencyCode', {
            error: new Error(err),
            context: { invalidCurrencyCode: code }
        });
        return null;
    }
};
